// extracted by mini-css-extract-plugin
module.exports = {"title":"DriverAlerts_title__2L2x-","text":"DriverAlerts_text__3ZBmr"};